/**
 * A horizontal progress bar that visually represents a percentage.
 *
 * @param {Object} props - The properties for the HorizontalProgressBar component.
 * @param {number} props.percentage - The completion percentage (0 to 100) to be displayed by the progress bar.
 * @param {string | number} props.width - The width of the progress bar container, e.g., "100%" or "200px".
 * @param {string | number} props.height - The height of the progress bar container, e.g., "20px" or "10%".
 * @param {string} [props.dataColor="red"] - The color of the filled portion of the progress bar.
 * @param {string} [props.backgroundColor="#ababab"] - The color of the background (unfilled portion) of the progress bar.
 * @param {Object} [props.style] - Additional custom styles to apply to the progress bar container.
 * @returns {JSX.Element} The rendered HorizontalProgressBar component.
 */
export const HorizontalProgressBar = ({
  percentage,
  width,
  height,
  dataColor,
  backgroundColor,
  style,
}) => {
  const fixedPercentage = Math.max(Math.min(percentage, 100), 0);

  return (
    <div
      style={{
        width: width,
        height: height,
        backgroundColor: backgroundColor ?? "#ababab",
        position: "relative",
        ...style,
      }}
    >
      <div
        style={{
          position: "absolute",
          backgroundColor: dataColor ?? "red",
          height: height,
          width: width,
          transform: `scaleX(${fixedPercentage / 100})`,
          transformOrigin: "top left",
        }}
      ></div>
    </div>
  );
};
